// ============================================================================
// Programmed Lists - Built-in system lists with special routes
// ============================================================================
// Standalone, dependency-free data module. It is kept separate from
// lists-management-page.js (which imports the heavy task-list modal + icon
// picker graph) so lightweight consumers - notably the sidebar, which renders
// these as pinned nav items - can import the constant WITHOUT dragging the
// whole lists page (and the ~1500-icon Font Awesome catalogue it transitively
// pulls in) into the app boot bundle.
// ============================================================================

export const PROGRAMMED_LISTS = [
    {
        id: 'tasks-programmed',
        name: 'Tasks',
        description: 'View and manage all tasks',
        icon: 'fa-tasks',
        is_programmed: true,
        programmed_route: '/tasks',
        sharing_type: 'public'
    },
    {
        id: 'reports-programmed',
        name: 'Reports',
        description: 'Analytics and reporting',
        icon: 'fa-chart-bar',
        is_programmed: true,
        programmed_route: '/reports',
        sharing_type: 'public'
    },
    {
        id: 'billing-programmed',
        name: 'Billing',
        description: 'Manage client billing and invoicing',
        icon: 'fa-file-invoice-dollar',
        is_programmed: true,
        programmed_route: '/billing',
        sharing_type: 'public'
    },
    {
        id: 'leave-calendar-programmed',
        name: 'Leave Calendar',
        description: 'Manage employee leave and public holidays',
        icon: 'fa-umbrella-beach',
        is_programmed: true,
        programmed_route: '/leave-calendar',
        sharing_type: 'public'
    },
    {
        id: 'activity-programmed',
        name: 'Activity',
        description: 'Track user actions across the platform',
        icon: 'fa-stream',
        is_programmed: true,
        programmed_route: '/activity',
        sharing_type: 'public'
    },
    {
        id: 'retainers-programmed',
        name: 'Retainers',
        description: 'Manage client retainer allocations across services',
        icon: 'fa-hand-holding-usd',
        is_programmed: true,
        programmed_route: '/retainers',
        sharing_type: 'public'
    },
    {
        id: 'supplier-bills-programmed',
        name: 'Supplier Bills',
        description: 'Pay-on-behalf bills (Sage, Xero) split across clients',
        icon: 'fa-file-invoice',
        is_programmed: true,
        programmed_route: '/supplier-bills',
        sharing_type: 'public'
    },
    {
        id: 'stats-programmed',
        name: 'Stats',
        description: 'Historical AFS leaderboards, medal tables, and per-user year-by-year totals',
        icon: 'fa-medal',
        is_programmed: true,
        programmed_route: '/stats',
        sharing_type: 'public'
    },
    {
        id: 'sign-off-programmed',
        name: 'Sign-off',
        description: 'Track AFS and Management Accounts sign-offs from invoice to signature',
        icon: 'fa-signature',
        is_programmed: true,
        programmed_route: '/sign-off',
        sharing_type: 'public'
    },
    {
        id: 'audit-planning-programmed',
        name: 'Audit Planning',
        description: 'Drag-and-drop calendar for scheduling audit fieldwork, stock takes and teams',
        icon: 'fa-calendar-check',
        is_programmed: true,
        programmed_route: '/audit-planning',
        sharing_type: 'public'
    },
    {
        id: 'provisionals-programmed',
        name: 'Provisionals',
        description: 'Provisional tax register and calculations (entities, individuals, trusts)',
        icon: 'fa-calculator',
        is_programmed: true,
        programmed_route: '/provisionals',
        sharing_type: 'public'
    },
    {
        id: 'drafter-programmed',
        name: 'Drafter',
        description: 'Draft management accounts and financial statements from a trial balance',
        icon: 'fa-file-invoice',
        is_programmed: true,
        programmed_route: '/drafter',
        sharing_type: 'public'
    }
];
